import './inner-tabs.scss';

import React from 'react';

interface IProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: {
    label: string;
    key: string;
  }[];
}

const InnerTabs: React.FC<IProps> = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div className="inner-tabs">
      {tabs.map((tab, index) => (
        <React.Fragment key={tab.key}>
          {index !== 0 && <div className="inner-tabs__divider" />}
          <div
            className={`inner-tabs__tab ${activeTab === tab.key ? 'inner-tabs__tab--active' : ''}`}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default InnerTabs;
